import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { areIAnchorPropsOf } from "../../cta.models";
import { Btn, A } from "./components";
export var Button = function(props) {
    if (areIAnchorPropsOf(props)) {
        return /*#__PURE__*/ _jsx(A, _object_spread({}, props));
    }
    return /*#__PURE__*/ _jsx(Btn, _object_spread({}, props));
};
